import { Link, Navigate, useParams } from "react-router-dom";
import styles from "./Fatura.module.css";
import { useEffect, useState } from "react";
import axios from "axios";
import load from "../../../../Images/loading.gif";
import { RiResetLeftLine } from "react-icons/ri";

function Fatura() {
    const { invoiceId } = useParams();
    const [fatura, setFatura] = useState(null);
    const [venda, setVenda] = useState(null);
    const [plano, setPlano] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const gerarNovoPagamento = async () => {
        try {
            const response = await fetch(`https://eclipsebots.com/api/faturas/newpayment`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify({ invoiceId: fatura.invoiceId, service: venda.serviceName, userId: user.id, planId: venda.systemId, amount: fatura.amount })
            });

            const data = await response.json();
            if (data.success) {
                window.location.href = data.link;
            } else {
                alert("Erro ao gerar novo pagamento.");
            }
        } catch (error) {
            console.error("Erro ao gerar novo link:", error);
            alert("Erro ao gerar novo pagamento.");
        }
    };


    useEffect(() => {
        axios.get("https://eclipsebots.com/api/profile", { withCredentials: true })
            .then((res) => {
                setUser(res.data);
            })
            .catch(() => {
                setUser(null);
            });

        const fetchAll = async () => {
            try {
                const invoiceRes = await fetch(`https://eclipsebots.com/api/faturas/fatura/${invoiceId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include"
                });

                if (!invoiceRes.ok) throw new Error("Erro ao buscar fatura");
                const invoiceData = await invoiceRes.json();
                const fatura = invoiceData[0];
                setFatura(fatura);

                const saleRes = await fetch(`https://eclipsebots.com/api/sales/${fatura.serviceId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include"
                });

                if (!saleRes.ok) throw new Error("Erro ao buscar venda");
                const saleData = await saleRes.json();
                const venda = saleData[0];
                setVenda(saleData[0]);
                const planRes = await fetch(`https://eclipsebots.com/api/planos/${venda.systemId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include"
                });

                if (!planRes.ok) throw new Error("Erro ao buscar plano");
                const planData = await planRes.json();
                setPlano(planData[0]);

            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, [invoiceId]);

    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    if (!user) {
        return <Navigate to="/" />;
    }

    const dateVencimento = new Date(fatura.dueDate);
    const dueDate = dateVencimento.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });

    const dateIssued = new Date(fatura.issuedAt);
    const issueDate = dateIssued.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });

    return (
        <div className={styles.invoiceContainer}>
            <div className={styles.invoice}>
                <div className={styles.invoiceHeader}>
                    <div>
                        <div className={styles.centerText}>
                            <img src="/logo.png" alt="Logo" className={styles.invoiceLogo} />
                            <h2>Fatura #{fatura.invoiceId}</h2>
                        </div>
                    </div>
                    <div>
                        <div className={styles.centerText}>
                            <p className={`${styles.status} ${fatura.status === "paid" ? styles.paid :
                                fatura.status === "cancelled" ? styles.cancelled :
                                    fatura.status === "failed" ? styles.failed :
                                        styles.open}`}>
                                {fatura.status === "paid" ? "PAGO" :
                                    fatura.status === "cancelled" ? "CANCELADO" :
                                        fatura.status === "failed" ? "FALHOU" :
                                            "EM ABERTO"}
                            </p>
                            <p>Vencimento: {dueDate}</p>
                        </div>
                    </div>
                </div>

                <hr />

                <div className={styles.spaceBetween}>
                    <div className={styles.invoiceSection}>
                        <h4>Faturado para</h4>
                        <p>
                            {user.username}
                        </p>
                    </div>

                    <div className={`${styles.invoiceSection} ${styles.right}`}>
                        <h4>Pagar a</h4>
                        <p>EclipseBots</p>
                    </div>
                </div>

                <div className={`${styles.spaceBetween} ${styles.top}`}>
                    <div className={styles.invoiceSection}>
                        <h4>Data da Fatura</h4>
                        <p>{issueDate}</p>
                    </div>

                    <div className={`${styles.invoiceSection} ${styles.right}`}>
                        <h4>Forma de Pagamento</h4>
                        <p>
                            {fatura.status === "pending" && (
                                <button onClick={gerarNovoPagamento} alt='Gerar Novo Pagamento'>
                                    <RiResetLeftLine />
                                </button>
                            )}
                            <a href={`${fatura.description}`} target="_blank" rel="noreferrer">
                                Mercado Pago
                            </a>
                        </p>
                    </div>
                </div>

                <div className={styles.invoiceTable}>
                    <h3>Fatura Itens</h3>
                    <table>
                        <thead>
                            <tr className={styles.white}>
                                <th>Descrição</th>
                                <th className={styles.valueColumn}>Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className={styles.white}>
                                <td>{plano.name} ({dueDate})<br />Ciclo de Pagamento: {venda.cycle}<br />Serviço: {venda.serviceName}</td>
                                <td className={styles.valueColumn}>R${fatura.amount} BRL</td>
                            </tr>
                            <tr>
                                <td className={styles.right}><strong>Sub-total</strong></td>
                                <td className={styles.valueColumn}>R${fatura.amount} BRL</td>
                            </tr>
                            <tr>
                                <td className={styles.right}><strong>Crédito</strong></td>
                                <td className={styles.valueColumn}>R$0,00 BRL</td>
                            </tr>
                            <tr className="total">
                                <td className={styles.right}><strong>Total</strong></td>
                                <td className={styles.valueColumn}>R${fatura.amount} BRL</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={styles.invoiceSection}>
                    <h4>Transações</h4>
                    <p>Nenhuma Transação Relacionada</p>
                </div>

                <div className={styles.invoiceActions}>
                    <button onClick={() => window.print()}>🖨️ Imprimir</button>
                    <button>📥 Download</button>
                </div>
            </div>
            <div className={styles.voltar}>
                <Link to={"/dashboard/faturas"}>Voltar</Link>
            </div>
        </div>
    );
}

export default Fatura;
